<template>

</template>

<script>
    import axios from 'axios'

    export default {
        name: "Logout",
        methods: {
            logout: function () {
                this.$globalStore.authed = false;
                this.$globalStore.group = 0;

                axios.delete('https://drop.rautec.de/api/auth/logout').then(response => {
                    this.$router.push('/');
                }).catch(reason => {
                    if (reason.response.status !== 403) {
                        this.$router.push('/');
                    }
                });
            }
        },
        mounted() {
            this.logout();
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Logout.vue